import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
const PLACEHOLDER_PHOTO = 'https://uploadthingy.s3.us-west-1.amazonaws.com/fZa81XHffrZCe8WfjqY5ov/profile_pic.png';

// Simple team card without expandable functionality
const TeamCard = ({
  name,
  title
}: {
  name: string;
  title: string;
}) => {
  return <div className="bg-gray-900/50 p-6 rounded-2xl border border-gray-800/50 text-white h-full flex flex-col" data-id="element-1142" data-mp="1eszxdtxlgb7p">
      <div className="aspect-[1/1] w-full mb-6 overflow-hidden rounded-xl" data-id="element-1143" data-mp="19t3sztkzihrm">
        <ImageFadeIn src={PLACEHOLDER_PHOTO} alt={`${name} profile`} className="w-full h-full object-cover" data-id="element-1144" data-mp="152f0qc1hdgrf" />
      </div>
      <div className="mt-auto" data-id="element-1145" data-mp="110tgu6qj427q">
        <h3 className="text-xl font-semibold text-white mb-1" data-id="element-1146" data-mp="1xiy3w5lqtw98">{name}</h3>
        <p className="text-gray-300 text-sm" data-id="element-1147" data-mp="1xl2h5e5j87m6">{title}</p>
      </div>
    </div>;
};
const leadershipTeam = [{
  name: 'David Stern',
  title: 'Director of Training',
  bio: "David Stern leads ICTF's civilian training efforts in Israel, overseeing the development and delivery of practical security and emergency preparedness training for individuals, families, and communities. David served as a U.S. Marine before moving to Israel and has since served in multiple roles within the IDF special operations community, where he continues to serve today. Based in Israel, David brings extensive hands-on experience to ICTF's mission of equipping civilians with the skills, confidence, and preparedness needed to respond when every second matters."
}];
const boardMembers = [{
  name: 'Tim M.',
  title: '35 year military security training expert'
}, {
  name: 'Rony J.',
  title: 'Experienced corporate security executive'
}, {
  name: 'Mo V.',
  title: 'Nationally recognized doctor and specialty surgeon'
}, {
  name: 'David S.',
  title: 'Nationally recognized corporate executive and leadership expert'
}, {
  name: 'David A.',
  title: 'Nationally recognized emergency management expert and trainer with 38 years of experience'
}, {
  name: 'Bert S.',
  title: '15 years as experienced business owner and licensed building contractor; 28 years professional teaching experience'
}];
const TeamPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" style={{
    backgroundImage: `url(https://uploadthingy.s3.us-west-1.amazonaws.com/ib3Dyczi1YEyT6WYET97wp/bgbluee2.png)`
  }} data-id="element-1148" data-mp="zno0izldnq8x">
      {/* Header Section */}
      <div className="pt-40 sm:pt-48 md:pt-56 pb-6 sm:pb-10" data-id="element-1149" data-mp="1mkpv917hdnz8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal px-4" data-id="element-1150" data-mp="1ikp3yfza9iar">
          Meet the Team
        </h1>
      </div>

      {/* Leadership Section */}
      <ScrollReveal animation="fade" data-id="element-1151" data-mp="2abvbvil8wkal">
        <section aria-labelledby="leadership-heading" className="pt-12 sm:pt-16 pb-8 sm:pb-12" data-id="element-1152" data-mp="2aatnkcf7y1ax">
          <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-1153" data-mp="3t07p8x2lc1o4">
            <h2 id="leadership-heading" className="text-2xl sm:text-3xl font-light text-white mb-8 sm:mb-10" data-id="element-1154" data-mp="1t3hfzymgben">
              Leadership
            </h2>
            <div className="space-y-8" data-id="element-1155" data-mp="at0aeds1nwfi">
              {leadershipTeam.map(leader => <article key={leader.name} className="bg-gray-900/50 rounded-2xl border border-gray-800/50 p-6 sm:p-8 grid grid-cols-1 md:grid-cols-[280px_1fr] gap-6 md:gap-10 items-start" data-id="element-1156" data-mp="fscyf1unj9jo">
                  <div className="aspect-[1/1] w-full max-w-[280px] overflow-hidden rounded-xl" data-id="element-1157" data-mp="pifzzqfu9vtm">
                    <ImageFadeIn src={PLACEHOLDER_PHOTO} alt={`${leader.name} profile`} className="w-full h-full object-cover" data-id="element-1158" data-mp="tigdn8v462zm" />
                  </div>
                  <div data-id="element-1159" data-mp="puoxl4sf6gzg">
                    <h3 className="text-2xl sm:text-3xl font-semibold text-white" data-id="element-1160" data-mp="ptx35xak6par">
                      {leader.name}
                    </h3>
                    <p className="text-blue-300 font-medium mt-1 mb-5" data-id="element-1161" data-mp="ktj6tcibl3sk">
                      {leader.title}
                    </p>
                    <p className="text-gray-200 text-base sm:text-lg leading-relaxed max-w-3xl" data-id="element-1162" data-mp="uloysm8knl7r">
                      {leader.bio}
                    </p>
                  </div>
                </article>)}
            </div>
          </div>
        </section>
      </ScrollReveal>

      {/* Board Section */}
      <ScrollReveal animation="fade" data-id="element-1163" data-mp="guadg8r6z7xj">
        <section aria-labelledby="board-heading" className="pt-8 sm:pt-12 pb-16 sm:pb-24" data-id="element-1164" data-mp="gvbpafg17ygb">
          <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-1165" data-mp="bxa5fsas7v3s">
            <h2 id="board-heading" className="text-2xl sm:text-3xl font-light text-white mb-8 sm:mb-10" data-id="element-1166" data-mp="1s7uktkx6pji8">
              Board of Directors
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-1167" data-mp="1usu1da7futou">
              {boardMembers.map(member => <TeamCard key={member.name} name={member.name} title={member.title} data-id="element-1168" data-mp="1zqc24dbay2lr" />)}
            </div>
          </div>
        </section>
      </ScrollReveal>
    </div>;
};
export default TeamPage;